
// Arrow.js
export default function Arrow() {
  return <div className="arrow"></div>
};
